import { FC, useMemo, useState } from "react";
import { NLSenderProspect } from "@models/Models";
import "./../NewsletterPicker/NewsletterPickerRow.scss";
import { ReactComponent as ChevronRightIcon } from "@images/chevron_right.svg";

interface ExpandableGroupRowProps {
	groupName: string;
	prospects: NLSenderProspect[];
}

const ExpandableGroupRow: FC<ExpandableGroupRowProps> = ({ groupName, prospects }) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const count = prospects.length;

	const sortedProspects = useMemo(() => {
		return [...prospects].sort((a, b) => (a?.sender_name || "").localeCompare(b?.sender_name || ""));
	}, [prospects]);

	return (
		<button className="flex flex-col w-full justify-between items-center gap-2 cursor-pointer select-newsletter-row transition ease-in-out hover:bg-white/20" onClick={() => setIsOpen(!isOpen)}>
			<div className="flex flex-row items-center justify-between w-full">
				<div className="text-white font-primary text-lg">{groupName}</div>
				<div className="flex items-center gap-3">
					<div className="text-white/70 font-primary">({count})</div>
					<ChevronRightIcon className={`w-[18px] h-[18px] fill-white transition-transform duration-300 ease-in-out ${isOpen ? "rotate-[270deg]" : "rotate-90"}`} />
				</div>
			</div>

			{isOpen && (
				<div className="mt-3 flex flex-col gap-2 w-full">
					{sortedProspects.map((p) => (
						<div key={p.sender_id} className="text-white font-primary text-sm text-left">
							{p.sender_name}
						</div>
					))}
				</div>
			)}
		</button>
	);
};

export default ExpandableGroupRow;
